import React from 'react'
import FormRadio from '../FormRadio'
import { isMobile } from 'helpers'

const isMobileBrowser = isMobile()

const DISPLAY_LABEL_MAP = {
  'Arrivals hall M&G': 'Arrival hall',
  'Curbside pick-up': 'Curbside',
}

const PickupInstructionOption = ({
  label,
  instruction,
  checked = false,
  onChange = () => {},
  id,
  type,
  otherInstruction = '',
  onOtherInstructionChange = () => {},
  editable = false,
  isAdminSide = false,
}) => {
  const handleClick = () => {
    if (onChange) {
      onChange()
    }
  }

  const containerClasses = [
    'pickup-option',
    isMobileBrowser ? 'pickup-option--mobile' : 'pickup-option--desktop',
    !isMobileBrowser && !isAdminSide && 'pickup-option--no-border',
    checked && 'pickup-option--checked',
  ]
    .filter(Boolean)
    .join(' ')

  const isOtherType = type === 'other'
  const showInstructionSection = isOtherType
    ? checked
    : isAdminSide
    ? checked
    : true

  return (
    <div
      onClick={handleClick}
      className={containerClasses}
      style={isAdminSide ? { backgroundColor: 'transparent' } : {}}
    >
      {isMobileBrowser && checked && (
        <div className='pickup-option__selected-label'>
          <img
            src='/images/icons/green-check.svg'
            alt=''
            className='pickup-option__selected-label-icon'
          />
          <span className='pickup-option__selected-label-text'>SELECTED</span>
        </div>
      )}
      <div
        className={`pickup-option__header${
          !showInstructionSection ? ' pickup-option__header--no-margin' : ''
        }`}
      >
        <div
          className='pickup-option__radio'
          onClick={e => e.stopPropagation()}
        >
          <FormRadio
            name='pickupInstruction'
            id={`${id}-radio`}
            label=''
            checked={checked}
            handleChange={() => {
              if (onChange) {
                onChange()
              }
            }}
            isUnselectable={true}
            className='mb-0'
            groupClassName='mb-0'
          />
        </div>
        <span className='pickup-option__label'>
          {DISPLAY_LABEL_MAP[label] ?? label}
        </span>
      </div>
      {showInstructionSection && (
        <>
          <div className='pickup-option__label-text'>PASSENGER INSTRUCTION</div>
          {isOtherType && checked ? (
            <textarea
              id='pickUpInstructionsText'
              className='pickup-option__content-textarea'
              placeholder='Enter detailed pick up location'
              defaultValue={otherInstruction || ''}
              onChange={e => {
                e.stopPropagation()
                onOtherInstructionChange(e.target.value)
              }}
              onClick={e => e.stopPropagation()}
            />
          ) : editable ? (
            <div
              id={id}
              className='pickup-option__content-textarea'
              contentEditable='plaintext-only'
              suppressContentEditableWarning={true}
              style={{ cursor: 'text' }}
              onClick={e => e.stopPropagation()}
              onBlur={e => {
                e.stopPropagation()
              }}
            >
              {instruction}
            </div>
          ) : (
            <div className='pickup-option__content'>{instruction}</div>
          )}
        </>
      )}
    </div>
  )
}

export default PickupInstructionOption
